export const STATUS_NEW = 'new'
export const STATUS_IN_REVIEW = 'in_review'
export const STATUS_COMPLETE = 'complete'
export const STATUS_REJECTED = 'rejected'

export const STATUS_OPTIONS = [
  { text: 'New', value: STATUS_NEW, },
  { text: 'In review', value: STATUS_IN_REVIEW, },
  { text: 'Complete', value: STATUS_COMPLETE, },
  { text: 'Rejected', value: STATUS_REJECTED, },
]

export const PERMISSION_GAME = 'game'
export const PERMISSION_WITHDRAW = 'withdraw'
export const PERMISSION_FAST_WITHDRAW = 'fast_withdraw'
export const PERMISSION_DEPOSIT = 'payment'
